import { z } from 'zod';

export const magicLinkAuthContainerSchema = z.object({
  email: z.email(),
});
